import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';

import {GetCanvas} from '../canvases/__generated/GetCanvas';
import {sessionStatusToBannerProps} from './SessionStatusMessage';

type SessionNode = NonNullable<
  ExtractByTypename<GetCanvas['benchlingAppCanvas'], 'BenchlingAppCanvasNode'>['session']
>;

type SessionMessageNode = SessionNode['messages'][number];

export interface SessionStatusContainerProps {
  session: SessionNode;
}

export function SessionStatusContainer(props: SessionStatusContainerProps): JSX.Element {
  const session = props.session;
  const messages = session?.messages;
  return messages ? (
    <div className={css(styles.messagesWrapper)}>
      <InlineBannerStack
        messages={messages.map((msg: SessionMessageNode) => sessionStatusToBannerProps(msg))}
      />
    </div>
  ) : (
    <></>
  );
}

const styles = StyleSheet.create({
  messagesWrapper: {
    marginTop: '12px',
  },
});
